import { Coupon } from '@core/models/swagger';
import { createAction, props } from '@ngrx/store';

export enum ProjectActions {
  ResetRuntime = '[Runtime] Reset runtime',
  UpdateQuotingId = '[Runtime] Update quoting id',
}

export const ResetRuntime = createAction(ProjectActions.ResetRuntime);

export const UpdateQuotingId = createAction(ProjectActions.UpdateQuotingId, props<{ data: string }>());
